export const LOADING_BLUE = "#2b4f7c";
